/*
 * Copyright (c) 2024 Pegasystems Inc.
 * All rights reserved.
 */

import { from } from 'rxjs';
import { map } from 'rxjs/operators';

import { logAndCatchError } from '../../utils/rxjs-utils';
import { resolveRestApi } from '../../router/app-router';
import { fetch } from '../../service_broker/fetch';
import { ACTION_GETOBJECT } from '../../store/state/actions';
import { processHeaders } from '../../store/state/epics/util';
import HeaderProcessor from '../../service_broker/header-processor';
import EnvironmentInfo from '../../environment-info';
import ObjectTransformer from '../../utils/object-transformer';

const GET_OBJECT_DXAPI_LOG_ERROR_MESSAGE = 'Error occurred during ajax call at getObject Epic : ';

export const executeGetObjectRequest = (
  actionInPayload: {
    pageName?: any;
    insKey?: any;
    headers?: any;
    context?: any;
    debugInfo?: any;
    viewType?: any;
  },
  options: { removeActionPayload: any }
) => {
  const { insKey, headers, context, debugInfo, viewType } = actionInPayload;
  const { removeActionPayload } = options;
  const pageName = actionInPayload?.pageName ? actionInPayload?.pageName : EnvironmentInfo.getDefaultCasePage();
  const restApiDetails = resolveRestApi(ACTION_GETOBJECT, {
    objectID: insKey,
    params: { pageName }
  });
  let { restApi } = restApiDetails;
  const { reqType } = restApiDetails;
  if (viewType === 'none') {
    restApi = `${restApi?.split('viewType')[0]}viewType=none`;
  }

  return from(
    fetch(
      restApi,
      {
        method: reqType,
        headers: {
          ...headers,
          ...(debugInfo && { ...HeaderProcessor.addDebugHeaders(debugInfo) })
        }
      },
      context
    )
  ).pipe(
    map((response) => {
      ObjectTransformer.analyseResponse(response.data);
      return {
        response: response.data,
        actionInPayload,
        headers: processHeaders({ ...headers, ...response.headers }),
        removeActionPayload
      };
    }),
    logAndCatchError(GET_OBJECT_DXAPI_LOG_ERROR_MESSAGE, context)
  );
};

export default executeGetObjectRequest;
